import { Box } from '@mui/material';
import { UserProfile } from '@clerk/clerk-react';
import { useTranslation } from 'react-i18next';

const UserProfileWrapper = () => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        width: '100%',
        mx: 'auto',
        p: 3,
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <UserProfile
          appearance={{
            elements: {
              card: {
                boxShadow: 'none',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
              },
              navbar: {
                backgroundColor: '#f5f5f5',
              },
              navbarButton: {
                '&:hover': {
                  backgroundColor: '#e0e0e0',
                },
              },
              profileSectionPrimaryButton: {
                '&.cl-button__emailAddresses': {
                  display: 'none',
                },
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default UserProfileWrapper;